import { Component, OnInit } from '@angular/core';
import { loadingProps } from 'src/utils/util.functions';
import { CrudService } from '../../services/crud.service';
import { Platform, LoadingController } from '@ionic/angular';
import { UtilService } from '../../services/util.service';

@Component({
    selector: 'app-points-withdrawal',
    templateUrl: './points-withdrawal.component.html',
    styleUrls: ['./points-withdrawal.component.scss'],
    standalone: false
})
export class PointsWithdrawalComponent implements OnInit {

  historicoPontos: any = [];
  pontosEmAberto: number = 0;
  valorEmAberto: number = 0;

  constructor(
    private _crudService: CrudService,
    private _platform: Platform,
    private _loadingController: LoadingController,
    private _util: UtilService) { }

  async ngOnInit() {
    await this.getPointsHistory();
  }

  private async getPointsHistory() {
    await this.showLoading();
    this._crudService
      .getData(`informativo/resgate/historico`)
      .subscribe(
        async (response: any) => {
          this.historicoPontos = response.data.historicoResgates;
          // this.historicoPontos = response.data;
          this.pontosEmAberto = response.data.pontosPendentes;
          this.valorEmAberto = response.data.valorPendente;
          await this.dismissLoad();
        },
        async () => {
          await this.dismissLoad();
          await this._util.showToast(
            "Error retrieving data. Please check your internet connection"
          );
        }
      );
  }

  public async redeemPoints() {
    await this.showLoading();
    this._crudService
      .postData("informativo/resgate", null, null)
      .subscribe(
        async (response: any) => {
          await this.dismissLoad();
          await this._util.showToast("Points redeemed successfully!");
          await this.getPointsHistory();
        },
        async () => {
          await this.dismissLoad();
          await this._util.showToast("Error redeeming points. Please try again later.");
          await this.getPointsHistory();
        }
      );
  }

  public canRedeem(): boolean {
    return this.valorEmAberto >= 5.0;
  }

  async showLoading() {
    loadingProps.mode = this._platform.is("ios") ? "ios" : "md";
    const loading = await this._loadingController.create(loadingProps);
    return await loading.present();
  }

  private async dismissLoad() {
    if (await this._loadingController.getTop()) {
      await this._loadingController.dismiss();
    }
  }

}
